import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconRestore } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { setChatHistoryVisible } from '../../actions';
/**
 * Implementation of a button for accessing chat history.
 */
class ChatHistoryButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityChatHistory';
    icon = IconRestore;
    label = 'toolbar.chatHistory';
    toggledLabel = 'toolbar.closeChatHistory';
    tooltip = 'toolbar.chatHistory';
    /**
     * Handles clicking the button, and opens/closes the chat history panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { _chatHistoryOpen, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('chat.history', {
            enable: !_chatHistoryOpen
        }));
        dispatch(setChatHistoryVisible(!_chatHistoryOpen));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._chatHistoryOpen;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _chatHistoryOpen: state['features/chat_history'].visible
    };
}
export default translate(connect(mapStateToProps)(ChatHistoryButton));
